import { NgModule }      from '@angular/core';
import { StateInternalPipe }   from './state-internal.pipe';
import { StateDataPipe }   from './state-data.pipe';
import { StateSearchPipe } from './state-search.pipe';
import { StateRoutingPipe } from './state-routing.pipe';
import { StateUserPipe } from './state-user.pipe'

@NgModule({
  imports:      [ ],
  declarations: [ ],
  providers: [ 
      StateDataPipe,
      StateInternalPipe,
      StateSearchPipe,
      StateRoutingPipe,
      StateUserPipe
    ],
  exports:      [ ],
})

export class InternalEffectsModule {
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/effect/effects.module.ts